<template>
    <modal :id="id" :loading="loading" :saveing="saveing" @shown="shown" @ok="save" @cancel="cancel">
        <span slot="modal-title">教師朝會出席統計表</span>
        <div class="row">
            <div class="col-md-6 col-sm-12">
                <form-input v-model="vm.SYear" id="SYear" label="學年度" type="number" required></form-input>
            </div>
            <div class="col-md-6 col-sm-12">
                <form-select v-model="vm.Semester" id="Semester" label="學期" required>
                    <div is="option" value="u">上</div>
                    <div is="option" value="d">下</div>
                </form-select>
            </div>
            <div class="col-12">
                <form-input v-model="vm.TeacherNo" id="ClassID" label="教師" type="text" required></form-input>
            </div>
            <div class="col-12">
                <form-date-input v-model="vm.Date" id="Date" label="日期" required></form-date-input>
            </div>
            <div class="col-12">
                <form-select v-model="vm.Attend" id="Attend" label="出席情形" required>
                    <div is="option" value="y">正常</div>
                    <div is="option" value="n">缺席</div>
                </form-select>
            </div>
        </div>
    </modal>
</template>

<script>
    import { detail } from '@/views';
    export default detail({
        name: 'morningmeetingTeacherDetail',
        api: '/api/morningmeetingteacher/'
    });
</script>

<style>
</style>